import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class RequisitionExceptionDataService
{

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(start, count, sortBy, sortDirection, filters) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
      return this.httpClient.get(url);
  }

  public getResolvedList(start, count, sortBy, sortDirection, filters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetResolvedList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }

  public getListByPackage(start, count, sortBy, sortDirection, filters, packageId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetListByPackage?start=${start}&packageId=${packageId}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }


  public getRequisitionException(id: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/Get?id=${id}`;
    return this.httpClient.get(url);
  }

  public getRequisitionByAccession(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetByAccession?accession=${accession}`;
    return this.httpClient.get(url);
  }

  public GetUnResolvedRequisitionExceptionByRequisition(id: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetUnResolvedRequisitionExceptionByRequisition?id=${id}`;
    return this.httpClient.get(url);
  }

  public DismissRequisitionException(id: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/DismissRequisitionException?id=${id}`;
    return this.httpClient.get(url);
  }

  public ResolveRequisitionException(id: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/ResolveRequisitionException?id=${id}`;
    return this.httpClient.get(url);
  }

  public ResolveLabelMismatch(id: string) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/ResolveLabelMismatch?id=${id}`;
    return this.httpClient.get(url);
  }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException/GetEmptyModel`;
      return this.httpClient.get(url);
   }

   public saveRequisitionException(req) {
      if (req.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException`;
         return this.httpClient.post(url, req);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionException?id=${req.Id}`;
         return this.httpClient.put(url, req);
      }
   }

}
